<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex md12>
        <div>
          <material-card>
            <v-form @submit.prevent="download" class="text-center">
              <v-btn
                :disabled="downloading"
                color="blue light"
                type="submit"
                >{{ $t("language.backupdownload") }}</v-btn
              >
            </v-form>
          </material-card>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "dbdownloadview",
  data() {
    return {
      downloading: false,
    };
  },
  methods: {
    download() {
      this.downloading = true;
      var formElement = document.createElement("form");

      formElement.setAttribute(
        "action",
        process.env.VUE_APP_API_URL + "client/utility/download/db"
      );
      const token = localStorage.getItem("token");
      formElement.innerHTML = `
				<input type='hidden' value='${token}' name='token'/>
			`;
      document.body.appendChild(formElement);
      formElement.submit();
      formElement.remove();
      let vm = this;
      setTimeout(() => {
        vm.downloading = false;
      }, 5000);
    },
  },
};
</script>